import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import { RealSaving } from "./real-savings-data";

export const getRealSavingsColumns = (): ColumnDef<RealSaving>[] => {
  return [
    {
      accessorKey: "feature",
      header: () => (
        <h3 className="text-left font-mobile text-white text-sm sm:text-[0.925rem] lg:text-base font-bold leading-normal">
          Feature
        </h3>
      ),
      cell: ({ row }) => (
        <p className="w-44 sm:w-52 lg:w-96 text-[#535862] text-xs sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-[1.125rem] lg:leading-5">
          {row.original.feature.includes("Total Monthly Savings") ? (
            <span className="inline-block uppercase text-[#1D1D1B] font-semibold mt-px">
              {row.original.feature}
            </span>
          ) : (
            row.original.feature
          )}
        </p>
      ),
    },
    {
      accessorKey: "vleMobile",
      header: () => (
        <h3 className="text-center font-mobile text-white text-sm sm:text-[0.925rem] lg:text-base font-bold leading-normal">
          VLE Mobile
        </h3>
      ),
      cell: ({ row }) => (
        <p className="w-44 sm:w-48 text-center text-[#535862] text-xs sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-[1.125rem] lg:leading-5 mx-auto">
          {row.original.vleMobile}
        </p>
      ),
    },
    {
      accessorKey: "others",
      header: () => (
        <h3 className="text-center font-mobile text-white text-sm sm:text-[0.925rem] lg:text-base font-bold leading-normal">
          Others
        </h3>
      ),
      cell: ({ row }) => (
        <p className="w-44 sm:w-48 text-center text-[#535862] text-xs sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-[1.125rem] lg:leading-5 mx-auto">
          {row.original.others}
        </p>
      ),
    },
    {
      accessorKey: "savings",
      header: () => (
        <h3 className="text-center font-mobile text-white text-sm sm:text-[0.925rem] lg:text-base font-bold leading-normal">
          Your Savings
        </h3>
      ),
      cell: ({ row }) => (
        <p className="w-44 sm:w-48 text-center text-[#1EC677] text-xs sm:text-[0.825rem] lg:text-sm font-medium leading-4 sm:leading-[1.125rem] lg:leading-5 mx-auto">
          {row.original.savings}
        </p>
      ),
    },
  ];
};
